/**
 * Atlas Lens ArrowRight Outlined Lg (24px) — Foundation `t9rSYPySbTWytcGTu7D1zl`.
 * Same path as `CarouselArrowIcon` / `@diligentcorp/atlas-react-icons` so Next matches Figma.
 */
const ARROW_RIGHT =
  'M13.8461 17.6534L12.7923 16.5688L16.6116 12.7495H4.5V11.2496H16.6116L12.7923 7.4303L13.8461 6.3457L19.5 11.9995L13.8461 17.6534Z';

export function NextArrowIcon() {
  return (
    <span className="cs-next__arrow" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path d={ARROW_RIGHT} fill="currentColor" />
      </svg>
    </span>
  );
}
